import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { SERVICES } from "@/data/services";
import { OFFICE, OFFICE_MAPS_URL } from "@/data/office";

const FIRM_LINKS = [
  { label: "About", href: "/#about" },
  { label: "Standards", href: "/#standards" },
  { label: "Contact", href: "/#contact" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#04162E] text-[#C7D1DC] pt-16 pb-7">
      <div className="mx-auto max-w-[1180px] px-5 lg:px-8">
        <div className="grid md:grid-cols-[1.3fr_1fr_1fr] gap-9 md:gap-12 pb-11 border-b border-white/[0.12]">
          <div>
            <Logo tagline={false} size={42} />
            <p className="mt-3.5 font-body text-[13.5px] text-[#93A3B6] leading-[1.6] max-w-[34ch]">
              Precision Process Safety &amp; Integrity Engineering Consultants — authoritative risk
              management and compliance engineering for high-hazard facilities.
            </p>
            <a
              href={OFFICE_MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-office-address"
              className="mt-4 inline-flex items-start gap-2 font-body text-[13.5px] text-[#93A3B6] hover:text-white leading-[1.6] transition-colors"
            >
              <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-[#0E8A57]" />
              <span>
                {OFFICE.line1}
                <br />
                {OFFICE.line2}
              </span>
            </a>
          </div>

          <div>
            <h5 className="font-body text-[12.5px] font-semibold text-white mb-4">SERVICES</h5>
            {SERVICES.slice(0, 6).map((s) => (
              <a
                key={s.id}
                href="/#services"
                className="block font-body text-[13.5px] text-[#93A3B6] hover:text-white py-1.5 transition-colors"
              >
                {s.title}
              </a>
            ))}
          </div>

          <div>
            <h5 className="font-body text-[12.5px] font-semibold text-white mb-4">FIRM</h5>
            {FIRM_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="block font-body text-[13.5px] text-[#93A3B6] hover:text-white py-1.5 transition-colors"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>

        <div className="pt-6 flex flex-wrap justify-between gap-3 font-body text-[12.5px] text-[#7488A0]">
          <span>
            © {new Date().getFullYear()} Process Safety &amp; Integrity Engineering Consultants (PSIEC). All rights reserved.
          </span>
          <span>
            <Link to="/privacy" data-testid="footer-privacy-link" className="underline hover:text-white transition-colors">
              Privacy Policy
            </Link>
            &nbsp;·&nbsp;
            <Link to="/terms" data-testid="footer-terms-link" className="underline hover:text-white transition-colors">
              Terms of Service
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
};
